// import { Outlet } from "react-router-dom";
// import {usePermissions} from "../hooks/usePermission";
// import {Card} from "primereact/card";
// import {Props} from "../types/permission";
//
//
// const PermissionGate = ({ permission }: Props) => {
//     const { hasPermission } = usePermissions();
//     const [resource, action] = permission.split(":");
//
//     if (!hasPermission(resource, action)) {
//         return (
//             <Card>
//                 <h2>Access Denied</h2>
//             </Card>
//         );
//     }
//     return <Outlet />;
// };
//
// export default PermissionGate;

import { Outlet } from "react-router-dom";
import { usePermissions } from "../hooks/usePermission";
import { Card } from "primereact/card";
import { Props } from "../types/permission";
import { useAuth } from "../hooks/useAuth";

const PermissionGate = ({ permission }: Props) => {
    const { hasPermission } = usePermissions();
    const { user } = useAuth();

    const [resource, action] = permission.split(":");

    const isSuperAdmin = user?.permissions?.includes("all");

    const allowed = isSuperAdmin || hasPermission(resource, action);

    if (!allowed) {
        return (
            <Card>
                <h2>Access Denied</h2>
            </Card>
        );
    }

    return <Outlet />;
};

export default PermissionGate;